
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class EventLogGrid extends SiteEntityGrid<EventLogRow, any> {
        protected getColumnsKey() { return 'Data.EventLog'; }
        protected getDialogType() { return EventLogDialog; }
        protected getIdProperty() { return EventLogRow.idProperty; }
        protected getLocalTextPrefix() { return EventLogRow.localTextPrefix; }
        protected getService() { return EventLogService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}